export function normalizeEmailDomain(emailDomain: string) {
  return emailDomain.trim().replace(/^@/, '').toLowerCase();
}

export const ORGANIZATION_DETAIL_PAGE_SIZE = 10;

export function filterBySearchQuery<T>(
  items: T[],
  searchQuery: string,
  getSearchableText: (item: T) => string
) {
  const normalizedQuery = searchQuery.trim().toLowerCase();
  if (!normalizedQuery) return items;

  return items.filter((item) =>
    getSearchableText(item).toLowerCase().includes(normalizedQuery)
  );
}

export function paginateItems<T>(
  items: T[],
  requestedPage: number,
  pageSize = ORGANIZATION_DETAIL_PAGE_SIZE
) {
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const page = Math.min(Math.max(requestedPage, 1), totalPages);
  const startIndex = (page - 1) * pageSize;

  return {
    items: items.slice(startIndex, startIndex + pageSize),
    page,
    startIndex,
    totalPages,
  };
}
